/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useCallback } from "react";
import { deleteProduct, getProduct } from "../../../shared/services/services";
import { ProductItem, ProductPages } from "../../../shared/services/interface";
import { closeLoading, notifyLoading, notifySuccess } from "src/assets/toastService";
import { errorHandling } from "src/shared/services/errorHandling";
import { saveProductsToIndexedDB } from "src/shared/utils/indexDB/indexedDB";

const useProducts = (deleted?: boolean, page?: number, limit?: number, sortField?: string, order?: string) => {
  const [product, setProduct] = useState<ProductItem[]>([]);
  const [loadingPro, setLoading] = useState<boolean>(true);
  const [productPage, setProductPage] = useState<ProductPages>();
  const [search, setSearch] = useState("");
  const [categoryId, setCategoryId] = useState("");

  /** 🔎 Debounced Search */
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 400);

    return () => clearTimeout(timer);
  }, [search]);

  /** 🚀 Fetch Products */
  const fetchProducts = useCallback(() => {
    setLoading(true);
    getProduct(deleted, page, limit, debouncedSearch || undefined, categoryId || undefined, sortField, order)
      .then((res) => {
        setProductPage(res.data);
        setProduct(res.data.result || []);
      })
      .catch((err) => {
        console.error(err);
        errorHandling(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [deleted, page, limit, debouncedSearch, categoryId, sortField, order]);

  /** 🚀 Trigger API */
  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  /** 🔄 Reload */
  const reloadProduct = () => {
    fetchProducts();
  };

  /** 🗑 Delete */
  const DeletedProduct = async (ids: string[]) => {
    setLoading(true);
    notifyLoading("Deleting product(s)...");

    try {
      await deleteProduct(ids);
      closeLoading();
      notifySuccess("Product deleted successfully!");
      fetchProducts();
    } catch (error) {
      closeLoading();
      errorHandling(error);
    } finally {
      setLoading(false);
    }
  };

  /** 📂 Category Filter */
  const categoryidBased = (id: string) => {
    setCategoryId(id);
  };

  /** 🔎 Product Search */
  const searchProduct = (value: string) => {
    setSearch(value);
  };

  const getProductindexDB = () => {
    getProduct(deleted, page, limit, debouncedSearch || undefined, categoryId || undefined, sortField, order)
      .then((res) => {
        setProductPage(res.data);
        setProduct(res.data.result || []);
        saveProductsToIndexedDB(res.data.result);
      })
      .catch((err) => {
        console.error(err);
        errorHandling(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    product,
    loadingPro,
    productPage,
    DeletedProduct,
    reloadProduct,
    categoryidBased,
    searchProduct,
    getProductindexDB,
  };
};

export default useProducts;
